import { DownloadIcon } from "components/common/Icons/DownloadIcon";
import { Loader } from "components/common/Icons/Loader/Loader";
import { Translate } from "components/common/Translate/Translate";
import { useDownloadButton } from "./useDownloadButton";

export const DownloadButton = () => {
    const { handleClick, isDownloading } = useDownloadButton();
    return (
        <button
            className={`flex items-center gap-2 px-5 py-3 rounded-xl text-white ${
                isDownloading
                    ? "bg-irGray-200 dark:bg-darkSurface-600 hover:bg-irGray-400 dark:hover:bg-darkSurface-400"
                    : "bg-irBlue-200 dark:bg-darkPrimary-100 hover:bg-irBlue-400 dark:hover:bg-darkPrimary-200"
            }`}
            onClick={handleClick}
        >
            {isDownloading ? (
                <Loader className="stroke-[var(--light-gray)]" width={20} height={15} />
            ) : (
                <DownloadIcon width={20} height={15} />
            )}
            <span className="capitalize">
                <Translate keyName="download" />
            </span>
        </button>
    );
};
